module.exports = __webpack_public_path__ + "img/inspiration-5.e496743.jpg";